import {
  // takeLatest,
  takeEvery,
  put,
  all,
  call,
} from 'redux-saga/effects';
import PingHandlerActionTypes from './ping-handler.types';
import axios from 'axios';

import { pingSuccess, pingFailure } from './ping-handler.actions';

export function* pingStart({ payload }) {
  const { url } = payload;
  //   console.log(start, end, url, target);

  try {
    let res = null;
    if (!url) {
      console.log('no URL to ping');
      return;
    }

    if (url.indexOf('api.uptimerobot.com') > -1) {
      res = yield call(axios, {
        url: `${url}`,
        method: 'post',
        data: {
          all_time_uptime_ratio: '1',
          response_times: '1',
          average_response_time: '1',
        },
      });
    } else {
      res = yield call(axios, {
        url: `${process.env.REACT_APP_LOCAL_URL}/${url}`,
        method: 'get',
      });
    }

    yield put(pingSuccess(res));
  } catch (error) {
    // yield call(pulse, { start: end, end: start, color: '#FF3333', svg });
    yield put(pingFailure(error));
  }
}

export function* onPingStart() {
  yield takeEvery(PingHandlerActionTypes.PING_START, pingStart);
}

export function* onPingStartById() {
  yield takeEvery(PingHandlerActionTypes.PING_BY_ID_START, pingStart);
}

export function* pingHandlerSagas() {
  yield all([call(onPingStart)]);
}
